<template lang="pug">
y-dialog(v-model="showDialog" max-width="500" persistent scrollable content-class="round-lg")
  v-card.pa-6
    v-card-title.pa-0
      div.text-xl Add medication
    v-card-text.pa-0
      //- Medication
      .my-5
        div.text-sm.font-semibold.neutral700--text.mb-1 {{ $t('medication') }}
        medication-dropdown(:parentMedication="selectedMedication" @changed="onChangeMedication")
        div.text-xs.px-2.pt-1.danger500--text(v-if="!hasSelectedMedication") Choose medication first before you can proceed to below fields
      v-row.my-5(no-gutters)
        //- Dosage
        v-col.mr-2
          div.text-sm.font-semibold.neutral700--text.mb-1 {{ $t('dosage') }}
          v-row(no-gutters)
            v-col.mr-2(cols="4")
              v-text-field.text-sm.round-xl(v-model.number="selectedMedication.dosage_value" outlined hide-details :loading="isFetching" type="number" dense :disabled="!hasSelectedMedication")
            v-col(cols="7")
              dosage-unit-dropdown(:selectedMedication="selectedMedication" :loading="isFetching" :disabled="!hasSelectedMedication")
        //- Frequency
        v-col
          div.text-sm.font-semibold.neutral700--text.mb-1 {{ $t('frequency') }}
          frequency-dropdown(:selectedMedication="selectedMedication" :loading="isFetching" :disabled="!hasSelectedMedication")
      v-row.my-5(no-gutters)
        //- Instruction
        v-col.mr-2
          div.text-sm.font-semibold.neutral700--text.mb-1 {{ $t('instruction') }}
          instruction-dropdown(:selectedMedication="selectedMedication" :loading="isFetching" :disabled="!hasSelectedMedication")
        //- Duration
        v-col
          div.text-sm.font-semibold.neutral700--text.mb-1 {{ $t('duration') }}
          duration-dropdown(:selectedMedication="selectedMedication" :loading="isFetching" :disabled="!hasSelectedMedication")
      v-row.my-5(no-gutters)
        //- Indication
        v-col(cols="6")
          div.text-sm.font-semibold.neutral700--text.mb-1 Indication
          indication-dropdown(:selectedMedication="selectedMedication" :loading="isFetching" :disabled="!hasSelectedMedication")
    v-card-actions.justify-end.pa-0
      v-btn.button-sm.mr-2(text color="neutral700" @click="showDialog = false") Cancel
      v-btn.button-sm.white--text(depressed color="neutral700" :disabled="!canSave" @click="onSave") Save
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MedicationDropdown from '@/components/clinic/document/prescriptionLetter/MedicationDropdown.vue'
import DosageUnitDropdown from '@/components/clinic/document/prescriptionLetter/DosageUnitDropdown.vue'
import FrequencyDropdown from '@/components/clinic/document/prescriptionLetter/FrequencyDropdown.vue'
import InstructionDropdown from '@/components/clinic/document/prescriptionLetter/InstructionDropdown.vue'
import DurationDropdown from '@/components/clinic/document/prescriptionLetter/DurationDropdown.vue'
import IndicationDropdown from '@/components/clinic/document/prescriptionLetter/IndicationDropdown.vue'

export default {
  components: {
    MedicationDropdown, DosageUnitDropdown, FrequencyDropdown, InstructionDropdown, DurationDropdown, IndicationDropdown
  },
  props: {
    open: {
      type: Boolean,
    },
    parentMedication: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedMedication: {},
      isFetching: false
    }
  },
  mounted () {
    if (this.parentMedication) {
      this.selectedMedication = { ...this.parentMedication }
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    hasSelectedMedication () {
      if (this.selectedMedication?.id) return true

      return false
    },
    canSave () {
      return this.hasSelectedMedication
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onChangeMedication (item) {
      this.fetchOneMedication(item)
    },
    async fetchOneMedication (item) {
      try {
        this.isFetching = true
        const { data } = await this.$axios.get(`/clinics/${this.company.slug}/medications/${item.id}`)
        this.selectedMedication = { ...data, dosage_value: data.dosage_value ?? 1 }
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    onSave () {
      this.$emit('save', this.selectedMedication)
      this.showDialog = false
    }
  },
}
</script>

<style scoped>
</style>